module.exports = __webpack_public_path__ + "img/gh-305em-02.prt.8a056e30.jpg";